export default function (routeName, params) {
    let my_params = params || {};
    return window.route(routeName, {...my_params});
}